import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings',
  templateUrl: './broadcastings.component.html',
  styleUrls: ['./broadcastings.component.scss']
})
export class BroadcastingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
